import axios from '@/apis/axios';
import { transformObjectValuesToUpperCase } from '@/transformer/transform';


class GenerateDocument
{
    static async all()
    {
        const response = await axios.get('/api/company-process/generated-documents');

        return response.data.data;
    }

    static async getFilterData(process)
    {
        const response = await axios.get(`/api/${process}/company-process/filter-options`);

        return response.data.data;
    }

    static async getGenerateDocumentLiveStatus(companyProcessId)
    {
        const response = await axios.get(`/api/admin/company-process/${companyProcessId}/status`);

        return response.data.data;
    }

    static async isProcessHasSignSignatureDocs(processName) {
        const response = await axios.get(`/api/admin/${processName}/has-sign-signature-documents`);

        return response.data.data;
    }
    
    // Annual Return Dormant Form
    static async getRequiredToGenerateDormantFormData()
    {
        const response = await axios.get('/api/dormant-form-require-data');

        return response.data.data;
    }

    static async getDormantForm(companyProcessId)
    {
        const response = await axios.get(`/api/dormant-form/${companyProcessId}`);

        return response.data.data;
    }

    static async generateDormantForm(data)
    {
        const response = await axios.post('/api/admin/generate-dormant-form/', data);

        return response.data.data;
    }

    static async generateStrikeOffForm(data)
    {
        const response = await axios.post('/api/admin/generate-strike-off-form/', data);

        return response.data.data;
    }

    static async getStrikeOffFormData(companyProcessId)
    {
        const response = await axios.get(`/api/strike-off/${companyProcessId}`);

        return response.data.data;
    }


    static async deleteDormantForm(id)
    {
        const response = await axios.delete(`/api/admin/dormant-form/${id}`);

        return response.data.data;
    }

    // agm form
    static async getRequiredDataToGenerateAGMForm()
    {
        const response = await axios.get('/api/agm-form-require-data');

        return response.data.data;
    }

    static async getAGMForm(companyProcessId)
    {
        const response = await axios.get(`/api/agm-form/${companyProcessId}`);

        return response.data.data;
    }

    static async generateAGMForm(data)
    {
        const response = await axios.post('/api/admin/generate-agm-form/', data);

        return response.data.data;
    }

    static async deleteAGMForm(id)
    {
        const response = await axios.delete(`/api/admin/agm-form/${id}`);

        return response.data.data;
    }

    // agm dispensation form
    static async getRequiredDataToGenerateAGMDispensationForm()
    {
        const response = await axios.get('/api/agm-dispensation-form-require-data');

        return response.data.data;
    }

    static async getAGMDispensationForm(companyProcessId)
    {
        const response = await axios.get(`/api/agm-dispensation-form/${companyProcessId}`);

        return response.data.data;
    }

    static async generateAGMDispensationForm(data)
    {
        const response = await axios.post('/api/admin/generate-agm-dispensation-form/', data);

        return response.data.data;
    }

    static async deleteAGMDispensationForm(id)
    {
        const response = await axios.delete(`/api/admin/agm-dispensation-form/${id}`);

        return response.data.data;
    }

    // region allotment form
    static async getAllotmentForm(companyProcessId)
    {
        const response = await axios.get(`/api/allotment-form/${companyProcessId}`);

        return response.data.data;
    }

    static async getCurrentAllotmentForm() {
        const response = await axios.get('/api/allotment-form');

        return response.data.data;
    }

    static async getCompletionRequiredData() {
        const response = await axios.get('/api/allotment-form-completion-required-data');

        return response.data.data;
    }

    static async storeShareCapital(data)
    {
        const response = await axios.post('/api/admin/allotment-form/share-capital', data);

        return response.data.data;
    }

    static async storeBeneficialOwners(data)
    {
        const response = await axios.post('/api/admin/allotment-form/beneficial-owners', data);

        return response.data.data;
    }

    static async storeRegistrableControllers(data)
    {
        const response = await axios.post('/api/admin/allotment-form/registrable-controllers', data);

        return response.data.data;
    }

    static async generateAllotmentForm(data)
    {
        const response = await axios.post('/api/admin/generate-allotment-form/', data);

        return response.data.data;
    }

    static async approveAllotmentForm(data)
    {
        const response = await axios.post(`/api/admin/approve-allotment_form`, data);

        return response.data.data;
    }

    static async deleteAllotmentForm(companyProcessId)
    {
        const response = await axios.delete(`/api/admin/allotment-form/${companyProcessId}`);

        return response.data.data;
    }
    // end region allotment form

    // region transfer form
    static async getTransferForm(companyProcessId)
    {
        const response = await axios.get(`/api/transfer-form/${companyProcessId}`);

        return response.data.data;
    }

    static async getCurrentTransferForm() {
        const response = await axios.get('/api/transfer-form');

        return response.data.data;
    }
   
    static async generateTransferForm(data)
    {
        const response = await axios.post('/api/admin/generate-transfer-form/', data);

        return response.data.data;
    }

    static async approveTransferForm(data)
    {
        const response = await axios.post(`/api/admin/approve-transfer-form`, data);

        return response.data.data;
    }

    static async deleteTransferForm(companyProcessId)
    {
        const response = await axios.delete(`/api/admin/transfer-form/${companyProcessId}`);

        return response.data.data;
    }
    // end region transfer form

    // strike of
    static async deleteStrikeOff(id)
    {
        const response = await axios.delete(`/api/admin/strike-off/${id}`);

        return response.data.data;
    }

    // change fye form
    static async getChangeFyeForm(companyProcessId)
    {
        const response = await axios.get(`/api/change-fye-form/${companyProcessId}`);

        return response.data.data;
    }

    static async generateChangeFyeForm(data) {
        const response = await axios.post('/api/admin/generate-change-fye-form/', data);

        return response.data.data;
    }

    static async deleteChangeFyeForm(id)
    {
        const response = await axios.delete(`/api/admin/change-fye-form/${id}`);

        return response.data.data;
    }

    // director fee form
    static async getRequiredDataToGenerateDirectorFee()
    {
        const response = await axios.get('/api/director-fee-form-require-data');

        return response.data.data;
    } 

    static async getDirectorFeeForm(companyProcessId)
    {
        const response = await axios.get(`/api/director-fee-form/${companyProcessId}`);
 
        return response.data.data;
    }
 
    static async generateDirectorFeeForm(data) {
        const response = await axios.post('/api/admin/generate-director-fee-form/', transformObjectValuesToUpperCase(data));
 
        return response.data.data;
    }
 
    static async deleteDirectorFeeForm(id)
    {
        const response = await axios.delete(`/api/admin/director-fee-form/${id}`);
 
        return response.data.data;
    }

    // change director form 
    static async getChangeDirectorForm(companyProcessId)
    {
        const response = await axios.get(`/api/change-director-form/${companyProcessId}`);

        return response.data.data;
    }

    static async getPendingDirectors()
    {
        const response = await axios.get('/api/change-director/pending-directors');

        return response.data.data;
    }

    static async getPendingNomineeDirectors()
    {
        const response = await axios.get('/api/change-director/pending-nominee-directors');

        return response.data.data;
    }

    static async approvePendingDirector(director) {
        const response = await axios.post('/api/admin/change-director/approve', director);

        return response.data.data;
    }

    static async generateChangeDirectorForm(data)
    {
        const response = await axios.post('/api/admin/generate-change-director-form', transformObjectValuesToUpperCase(data));

        return response.data.data;
    }

    static async deleteChangeDirectorForm(id)
    {
        const response = await axios.delete(`/api/admin/change-director-form/${id}`);

        return response.data.data;
    }

    // change nominator form
    static async getChangeNominatorForm(companyProcessId)
    {
        const response = await axios.get(`/api/change-nominator-form/${companyProcessId}`);

        return response.data.data;
    }

    static async approveChangeNominator(companyProcessId) {
        const response = await axios.post(`/api/admin/approve-change-nominator/${companyProcessId}`);

        return response.data.data;
    }

    static async generateChangeNominatorForm(data)
    {
        const response = await axios.post('/api/admin/generate-change-nominator-form', transformObjectValuesToUpperCase(data));

        return response.data.data;
    }

    static async deleteChangeNominatorForm(id)
    {
        const response = await axios.delete(`/api/admin/change-nominator-form/${id}`);

        return response.data.data;
    }
    // end change nominator form

    // change shareholder nominator form
    static async getChangeShareholderNominatorForm(companyProcessId)
    {
        const response = await axios.get(`/api/change-shareholder-nominator-form/${companyProcessId}`);

        return response.data.data;
    }

    static async approveChangeShareholderNominator(companyProcessId) {
        const response = await axios.post(`/api/admin/approve-change-shareholder-nominator/${companyProcessId}`);

        return response.data.data;
    }

    static async generateChangeShareholderNominatorForm(data)
    {
        const response = await axios.post('/api/admin/generate-change-shareholder-nominator-form', transformObjectValuesToUpperCase(data));

        return response.data.data;
    }

    static async deleteChangeShareholderNominatorForm(id)
    {
        const response = await axios.delete(`/api/admin/change-shareholder-nominator-form/${id}`);

        return response.data.data;
    }
    // end change nominator form

    // strike off form    
    static async getRequiredDataToGenerateStrikeOffData()
    {
        const response = await axios.get('/api/strike-off-require-data');

        return response.data.data;
    } 

    static async getRequiredDataToGenerateShareTransferData()
    {
        const response = await axios.get('/api/share-transfer-require-data');

        return response.data.data;
    } 

    // change auditor
    static async getRequiredDataToGenerateChangeAuditor()
    {
        const response = await axios.get('/api/change-auditor-require-data');

        return response.data.data;
    } 

    static async getChangeAuditorForm(companyProcessId)
    {
        const response = await axios.get(`/api/change-auditor-form/${companyProcessId}`);
 
        return response.data.data;
    }
 
    static async generateChangeAuditorForm(data) {
        const response = await axios.post('/api/admin/generate-change-auditor-form/', transformObjectValuesToUpperCase(data));
 
        return response.data.data;
    }
 
    static async deleteChangeAuditorForm(id)
    {
        const response = await axios.delete(`/api/admin/change-auditor-form/${id}`);
 
        return response.data.data;
    }

    static async approveChangeAuditorForm(data)
    {
        const response = await axios.post(`/api/admin/approve-change-auditor-form`, data);
 
        return response.data.data;
    }

    // change register office address
    static async getChangeRegisterOfficeAddressForm(companyProcessId)
    {
        const response = await axios.get(`/api/change-ro-form/${companyProcessId}`);

        return response.data.data;
    }

    static async generateChangeRegisterOfficeAddressForm(data) {
        const response = await axios.post('/api/admin/generate-change-ro-form/', transformObjectValuesToUpperCase(data));

        return response.data.data;
    }

    static async deleteChangeRegisterOfficeAddressForm(id)
    {
        const response = await axios.delete(`/api/admin/change-ro-form/${id}`);

        return response.data.data;
    }
   
    static async approveChangeRegisterOfficeAddressForm(id)
    {
        const response = await axios.post(`/api/admin/change-ro-form/${id}/approve`);

        return response.data.data;
    }

    // change business activities form
    static async getChangeBusinessActivitiesForm(companyProcessId)
    {
        const response = await axios.get(`/api/change-business-activities-form/${companyProcessId}`);
   
        return response.data.data;
    }
   
    static async generateChangeBusinessActivitiesForm(data) {
        const response = await axios.post('/api/admin/generate-change-business-activities-form/', data);
   
        return response.data.data;
    }
   
    static async deleteChangeBusinessActivitiesForm(id)
    {
        const response = await axios.delete(`/api/admin/change-business-activities-form/${id}`);
   
        return response.data.data;
    }

    static async approvePendingBusinessActivitiesForm(id) {
        const response = await axios.post(`/api/admin/change-business-activities-form/${id}/approve`);
   
        return response.data.data;
    }

    // interim dividend
    static async getInterimDividendForm(companyProcessId)
    {
        const response = await axios.get(`/api/interim-dividend-form/${companyProcessId}`);
 
        return response.data.data;
    }
 
    static async generateInterimDividendForm(data) {
        const response = await axios.post('/api/admin/generate-interim-dividend-form/', data);
 
        return response.data.data;
    }
 
    static async deleteInterimDividendForm(id)
    {
        const response = await axios.delete(`/api/admin/interim-dividend-form/${id}`);
 
        return response.data.data;
    }

    // share cancellation form
    static async getRequiredDataToGenerateShareCancellationForm() {
        const response = await axios.get(`/api/share-cancellation-form-require-data`);
 
        return response.data.data;
    }

    static async getShareCancellationForm(companyProcessId)
    {
        const response = await axios.get(`/api/share-cancellation-form/${companyProcessId}`);
 
        return response.data.data;
    }
 
    static async generateShareCancellationForm(data) {
        const response = await axios.post('/api/admin/generate-share-cancellation-form/', data);
 
        return response.data.data;
    }
 
    static async deleteShareCancellationForm(id)
    {
        const response = await axios.delete(`/api/admin/share-cancellation-form/${id}`);
 
        return response.data.data;
    }

    static async approveShareCancellation(data)
    {
        const response = await axios.post('/api/admin/approve-share-cancellation-form', data);

        return response.data.data;
    }

    // share buy back form
    static async getShareBuyBackForm(companyProcessId)
    {
        const response = await axios.get(`/api/share-buy-back-form/${companyProcessId}`);
 
        return response.data.data;
    }

    static async generateShareBuyBackForm(data) {
        const response = await axios.post('/api/admin/generate-share-buy-back-form/', data);
 
        return response.data.data;
    }
 
    static async deleteShareBuyBackForm(id)
    {
        const response = await axios.delete(`/api/admin/share-buy-back-form/${id}`);
 
        return response.data.data;
    }

    static async approveShareBuyBackForm(data)
    {
        const response = await axios.post('/api/admin/approve-share-buy-back-form', data);

        return response.data.data;
    }

    // update particulars of director
    static async getParticularsOfDirectorForm(companyProcessId)
    {
        const response = await axios.get(`/api/update-particulars-of-director-form/${companyProcessId}`);
 
        return response.data.data.data;
    }
 
    static async generateParticularsOfDirectorForm(data) {
        const response = await axios.post('/api/admin/generate-update-particulars-of-director-form/', data);
 
        return response.data.data;
    }
 
    static async deleteParticularsOfDirectorForm(id)
    {
        const response = await axios.delete(`/api/admin/update-particulars-of-director-form/${id}`);
 
        return response.data.data;
    }

    static async approveParticularsOfDirectorForm(data)
    {
        const response = await axios.post('/api/admin/approve-update-particulars-of-director-form', data);

        return response.data.data;
    }

    // update particulars of shareholder
    static async getParticularsOfShareholderForm(companyProcessId)
    {
        const response = await axios.get(`/api/update-particulars-of-shareholder-form/${companyProcessId}`);
 
        return response.data.data.data;
    }
 
    static async generateParticularsOfShareholderForm(data) {
        const response = await axios.post('/api/admin/generate-update-particulars-of-shareholder-form/', data);
 
        return response.data.data;
    }
 
    static async deleteParticularsOfShareholderForm(id)
    {
        const response = await axios.delete(`/api/admin/update-particulars-of-shareholder-form/${id}`);
 
        return response.data.data;
    }

    static async approveParticularsOfShareholderForm(data)
    {
        const response = await axios.post('/api/admin/approve-update-particulars-of-shareholder-form', data);

        return response.data.data;
    }

    static async cancelProcess(companyProcessId)
    {
        const response = await axios.post(`/api/admin/cancel-process/${companyProcessId}`);

        return response.data.data;
    }

    // sale of property with option form
    static async getRequiredDataToGenerateSaleOfProperty()
    {
        const response = await axios.get('/api/sale-of-property-with-option-form-require-data');

        return response.data.data;
    } 

    static async getSaleOfPropertyForm(companyProcessId)
    {
        const response = await axios.get(`/api/sale-of-property-with-option-form/${companyProcessId}`);
 
        return response.data.data;
    }
 
    static async generateSaleOfPropertyForm(data) {
        const response = await axios.post('/api/admin/generate-sale-of-property-with-option-form/', data);
 
        return response.data.data;
    }
 
    static async deleteSaleOfPropertyForm(id)
    {
        const response = await axios.delete(`/api/admin/sale-of-property-with-option-form/${id}`);
 
        return response.data.data;
    }

    // secretary resignation form
    static async getSecretariesResignationForm(companyProcessId)
    {
        const response = await axios.get(`/api/secretaries-resignation-form/${companyProcessId}`);
 
        return response.data.data;
    }
 
    static async generateSecretariesResignationForm(data) {
        const response = await axios.post('/api/admin/generate-secretaries-resignation-form/', data);
 
        return response.data.data;
    }

    static async approveChangeSecretaryForm(secretaryResignationForm)
    {
        const response = await axios.post(`/api/admin/secretaries_resignation_form/${secretaryResignationForm.changeSecretaryFormId}/approve`, secretaryResignationForm);

        return response.data.data;
    }
 
    static async deleteSecretariesResignationForm(id)
    {
        const response = await axios.delete(`/api/admin/secretaries-resignation-form/${id}`);
 
        return response.data.data;
    }

    // update of paid up share capital
    static async getCapitalPaymentForm(companyProcessId)
    {
        const response = await axios.get(`/api/capital-payment-form/${companyProcessId}`);
 
        return response.data.data;
    }

    static async generateCapitalPaymentForm(data) {
        const response = await axios.post('/api/admin/generate-capital-payment-form/', data);
 
        return response.data.data;
    }
 
    static async deleteCapitalPaymentForm(id)
    {
        const response = await axios.delete(`/api/admin/capital-payment-form/${id}`);
 
        return response.data.data;
    }

    static async approveCapitalPaymentForm(data)
    {
        const response = await axios.post('/api/admin/approve-capital-payment-form', data);

        return response.data.data;
    }

    // data protection officer
    static async getDataProtectionOfficerForm(companyProcessId)
    {
        const response = await axios.get(`/api/data-protection-officer-form/${companyProcessId}`);
 
        return response.data.data;
    }

    static async generateDataProtectionOfficerForm(data) {
        const response = await axios.post('/api/admin/generate-data-protection-officer-form/', data);
 
        return response.data.data;
    }
 
    static async deleteDataProtectionOfficerForm(id)
    {
        const response = await axios.delete(`/api/admin/data-protection-officer-form/${id}`);
 
        return response.data.data;
    }

    static async approveDataProtectionOfficerForm(data)
    {
        const response = await axios.post('/api/admin/approve-data-protection-officer-form', data);

        return response.data.data;
    }

    // change of company name
    static async getChangeOfCompanyNameForm(companyProcessId)
    {
        const response = await axios.get(`/api/change-of-company-name-form/${companyProcessId}`);
 
        return response.data.data;
    }

    static async generateChangeOfCompanyNameForm(data) {
        const response = await axios.post('/api/admin/generate-change-of-company-name-form/', data);
 
        return response.data.data;
    }
 
    static async deleteChangeOfCompanyNameForm(id)
    {
        const response = await axios.delete(`/api/admin/change-of-company-name-form/${id}`);
 
        return response.data.data;
    }

    static async approveChangeOfCompanyNameForm(data)
    {
        const response = await axios.post('/api/admin/approve-change-of-company-name-form', data);

        return response.data.data;
    }
}

export default GenerateDocument;